var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6577_36272)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9422 8.13553C16.9422 10.9437 14.6656 13.2203 11.8575 13.2203C9.04909 13.2203 6.77271 10.9437 6.77271 8.13553C6.77271 5.32733 9.04909 3.05078 11.8575 3.05078C14.6656 3.05078 16.9422 5.32733 16.9422 8.13553Z",
    fill: "#FDD020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8575 2.0339C11.6701 2.0339 11.5185 1.88212 11.5185 1.69492V0.338983C11.5185 0.151781 11.6701 0 11.8575 0C12.0447 0 12.1965 0.151781 12.1965 0.338983V1.69492C12.1965 1.88212 12.0447 2.0339 11.8575 2.0339Z",
    fill: "#FDD020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6541 8.47435H18.2982C18.1108 8.47435 17.9592 8.32257 17.9592 8.13537C17.9592 7.94817 18.1108 7.79639 18.2982 7.79639H19.6541C19.8413 7.79639 19.9931 7.94817 19.9931 8.13537C19.9931 8.32257 19.8413 8.47435 19.6541 8.47435Z",
    fill: "#FDD020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9252 12.5422C15.6773 12.5422 15.4298 12.567 15.1869 12.616C15.0036 11.7015 14.4112 10.9214 13.5795 10.4992C12.7479 10.0769 11.7686 10.0592 10.9221 10.451C10.1561 8.34098 7.82458 7.25153 5.71454 8.01756C3.6045 8.78374 2.51506 11.1152 3.28108 13.2253C1.43273 13.2837 -0.0273166 14.8134 0.000325044 16.6626C0.0281323 18.5116 1.53353 19.9968 3.38287 19.9998H15.9252C17.9845 19.9998 19.6541 18.3304 19.6541 16.271C19.6541 14.2116 17.9845 12.5422 15.9252 12.5422Z",
    fill: "#A3D4F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11167 3.39011L5.75574 2.03418L7.11167 3.39011Z",
    fill: "#FDD020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11169 3.72896C7.02165 3.72896 6.93558 3.69321 6.87202 3.62965L5.51609 2.27372C5.42787 2.18864 5.39261 2.06252 5.42356 1.94401C5.45468 1.82549 5.54721 1.73297 5.66572 1.70202C5.78423 1.6709 5.91019 1.70632 5.99543 1.79438L7.35137 3.15031C7.44819 3.2473 7.47716 3.39313 7.42469 3.51975C7.37222 3.64637 7.24874 3.72896 7.11169 3.72896Z",
    fill: "#FDD020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6032 3.39011L17.9591 2.03418L16.6032 3.39011Z",
    fill: "#FDD020"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6032 3.72896C16.466 3.72896 16.3425 3.64637 16.29 3.51975C16.2376 3.39313 16.2665 3.2473 16.3635 3.15031L17.7195 1.79438C17.8045 1.70632 17.9305 1.6709 18.049 1.70202C18.1675 1.73297 18.2602 1.82549 18.2912 1.94401C18.3221 2.06252 18.2869 2.18864 18.1988 2.27372L16.8429 3.62965C16.7793 3.69321 16.6931 3.72896 16.6032 3.72896Z",
    fill: "#FDD020"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6577_36272"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.017880989175103e9100b18720c87349.svg";
export { ForwardRef as ReactComponent };